import { createBrowserRouter } from "react-router-dom";
import Root from "./content/Root";
import LoginPage from "./content/authPage/LoginPage";
import Homepage from "./content/Homepage";
import Summary from "./content/summary";
import Members from "./content/members";
import Data from "./content/data";
import DataStructure from "./content/dataStructure";
import MyPage from "./content/mypage";
import MembersMain from "./content/members/MembersMain";
import MembersEdit from "./content/members/MembersEdit";
import SumData from "./content/data/sumData";
import ShowData from "./content/data/sumData/ShowData";
import CreateData from "./content/data/sumData/CreateData";
import RealTimeMonitoring from "./content/data/monitoring";
import Model from "./content/dataStructure//model";
import UserRank from "./content/dataStructure//userRank";
import ShowMonitDataStructures from "./content/dataStructure/rawData/ShowMonitDataStructures";
import EditMonitDataStructure from "./content/dataStructure/rawData/EditMonitDataStructure";
import CreateMonitDataStructure from "./content/dataStructure/rawData/CreateMonitDataStructure";
import ShowMyData from "./content/mypage/ShowMyData";
import EditMyData from "./content/mypage/EditMyData";
import RegisterPage from "./content/authPage/RegisterPage";
import VerifyEmail from "./content/authPage/VerifyEmail";
import ResendAuthMail from "./content/authPage/ResendAuthMail";
import NotVerifiedYet from "./content/authPage/NotVerifiedYet";
import NaverLoginReq from "./content/authPage/NaverLoginReq";
import SocialRegisterPage from "./content/authPage/SocialRegisterPage";
import ChangePw from "./content/authPage/ChangePw";
import DataDetail from "./content/data/sumData/DataDetail";
import DetailedDataStructs from "./content/dataStructure/rawData";
import SumDataStructs from "./content/dataStructure/sumData";
import ShowSumDataStructs from "./content/dataStructure/sumData/ShowSumDataStructs";
import EditSumDataStruct from "./content/dataStructure/sumData/EditSumDataStruct";
import CreateSumDataStruct from "./content/dataStructure/sumData/CreateSumDataStruct";
import Organization from "./content/dataStructure//organization";
import ProcessStatus from "./content/processStatus";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                path: "home",
                element: <Homepage />,
                children: [
                    {
                        index: true,
                        path: "",
                        element: <Summary />,
                    },
                    {
                        path: "members",
                        element: <Members />,
                        children: [
                            {
                                index: true,
                                path: "",
                                element: <MembersMain />,
                            },
                            {
                                path: "edit/:id",
                                element: <MembersEdit />,
                            },
                        ]
                    },
                    {
                        path: "processStatus",
                        element: <ProcessStatus />,
                    },
                    {
                        path: "data",
                        element: <Data />,
                        children: [
                            {
                                path: "sumData",
                                element: <SumData />,
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShowData />,
                                    },
                                    {
                                        path: "detail",
                                        element: <DataDetail />,
                                    },
                                    {
                                        path: "create",
                                        element: <CreateData />,
                                    },
                                ]
                            },
                            {
                                path: "monitoring",
                                element: <RealTimeMonitoring />,
                            },

                        ]
                    },
                    {
                        path: "dataStructure",
                        element: <DataStructure />,
                        children: [
                            {
                                path: "monitoring",
                                element: <DetailedDataStructs />,
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShowMonitDataStructures />,
                                    },
                                    {
                                        path: "edit/:id",
                                        element: <EditMonitDataStructure />,
                                    },
                                    {
                                        path: "create",
                                        element: <CreateMonitDataStructure />,
                                    },
                                ]
                            },
                            {
                                path: "sumData",
                                element: <SumDataStructs />,
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShowSumDataStructs />,
                                    },
                                    {
                                        path: "edit/:id",
                                        element: <EditSumDataStruct />,
                                    },
                                    {
                                        path: "create",
                                        element: <CreateSumDataStruct />,
                                    },

                                ]
                            },
                            {
                                path: "model",
                                element: <Model />,
                            },
                            {
                                path: "userRank",
                                element: <UserRank />,
                            },
                            {
                                path: "organization",
                                element: <Organization />
                            },
                        ]
                    },
                    // {
                    //     path: "dataView",
                    //     element: <DataView />,
                    //     children: [
                    //         {
                    //             path: "sumData",
                    //             element: <SumDataView />
                    //         },
                    //         {
                    //             path: "monitoring",
                    //             element: <RawDataView />
                    //         }
                    //     ]
                    // },
                    {
                        path: "mypage",
                        element: <MyPage />,
                        children: [
                            {
                                index: true,
                                path: "",
                                element: <ShowMyData />,
                            },
                            {
                                path: "edit",
                                element: <EditMyData />,
                            },
                        ]
                    }
                ]
            },
            {
                index: true,
                path: "",
                element: <LoginPage />,
            },
            {
                path: "register",
                element: <RegisterPage />,
            },
            {
                path: "socialRegister",
                element: <SocialRegisterPage />,
            },
            {
                path: "notVerifiedYet/:id",
                element: <NotVerifiedYet />,
            },
            {
                path: "naverLoginReq",
                element: <NaverLoginReq />,
            },
            {
                path: "verifyEmail",
                element: <VerifyEmail />,
            },
            {
                path: "resendAuthMail",
                element: <ResendAuthMail />,
            },
            {
                path: "changePw",
                element: <ChangePw />,
            }
        ]
    }
])